<h2 mat-dialog-title>Alterar etapa inicial?</h2>
<mat-dialog-content>
  <p class="descricao-modal">
    Cada processo só pode ter <strong>uma</strong> etapa inicial. Em "{{ data.tipoNome }}", esse papel é de
    "{{ data.nomeAnterior }}".
  </p>
  <div class="transfer-pill">
    <span>{{ data.nomeAnterior }}</span>
    <mat-icon>east</mat-icon>
    <span class="novo">{{ data.nomeNovo }}</span>
  </div>
  <p class="descricao-modal mt-2">Deseja transferir a etapa inicial para "{{ data.nomeNovo }}"?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button class="btn-secondary" (click)="cancelar()">Manter "{{ data.nomeAnterior }}"</button>
  <button mat-flat-button class="btn-primary" (click)="confirmar()">Transferir</button>
</mat-dialog-actions>
